import React, { useState } from "react";
import CustomFieldModal from "./CustomFieldModal";
import useCustomField from "../../../../../hooks/useCustomField/UseCustomField";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import EditCustomFieldModal from "./EditCustomFieldModal";
import useUpdateCustomField from "../../../../../hooks/useCustomField/useUpdateCustomField";
import useEditCustomField from "../../../../../hooks/useCustomField/useEditCustomField";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import axios from "axios";
import AssignedToMain from "./AssignedToPopup/AssignedToMain";
import { ToastContainer, toast } from "react-toastify";
import FieldEditModal from "./FieldEditModal/FieldEditModal";

const BuyerManagementDetails = ({
  data,
  setData,
  dynamicFields = [],
  require,
  hidden,
  onFieldChange, // Accept onFieldChange prop from parent
  Message,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fieldToDelete, setFieldToDelete] = useState(null);
  const [division, setDivision] = useState("");
  const [message, setMessage] = useState({ type: "", text: "" });

  const { submitCustomField } = useCustomField();
  const { updateCustomField } = useUpdateCustomField();
  const apiUrls = process.env.REACT_APP_API_URLS;

  // console.log(dynamicFields);
  // console.log(data);

  const {
    showEditModal,
    selectedField,
    handleOpenEditModal,
    handleCloseEditModal,
    handleSubmitUpdateField,
  } = useEditCustomField();

  // Handle form submission for adding a new field
  const handleSubmit = async (data) => {
    const result = await submitCustomField(data);
    if (result.success) {
      toast.success("Field is Added Succefully", {
        position: "top-right",
        autoClose: 600,
      });
      // setMessage({ type: "success", text: result.message });
      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 700);
    } else {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 1000,
      });
      setShowModal(false);
    }
  };

  // Open Add Field Modal
  const handleOpenModal = () => {
    setDivision("Buyer Management Details");
    setShowModal(true);
  };

  // Open Delete Confirmation Modal
  const handleDeleteField = (field) => {
    setFieldToDelete(field);
    setShowDeleteModal(true);
  };

  // Confirm deletion of the field
  const handleConfirmDelete = async () => {
    if (fieldToDelete) {
      try {
        const response = await axios.delete(
          `${apiUrls}/buyer_settings/custom-fields/${fieldToDelete.id}/`
        );

        if (response.status === 204 || response.status === 200) {
          window.location.reload();
          setMessage({ type: "success", text: "Field deleted successfully!" });
        } else {
          setMessage({ type: "error", text: "Failed to delete the field." });
        }
      } catch (error) {
        setMessage({
          type: "error",
          text: "An error occurred while deleting the field.",
        });
      } finally {
        setShowDeleteModal(false);
        setFieldToDelete(null);
      }
    }
  };

  // Close Delete Confirmation Modal
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setFieldToDelete(null);
  };

  // Handle input changes and notify parent
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    // Update the specific field in the data object
    setData((prevData) => ({
      ...prevData,
      [field.column_name]: value,
    }));
    console.log(`${field.column_name}:${value}`);
    onFieldChange(field.column_name || field.name, value); // Notify parent of the change
  };

       const [isEditModalOpen, setEditModalOpen] = useState(false)
    const [formData, setFormData] = useState({
      label: '',
      placeholder: '',
      type: 'required',
    });
  
    const handleSave = () => {
      console.log("Form Data Saved:", formData);
      setEditModalOpen(false);
    };

  return (
    <>
      <div className="border-2 border-gray-200 shadow-lg rounded-md p-6 mt-8">
        <h2 className="text-lg font-semibold mb-4">
          <span className="underline">Buyer Management Details :</span>
        </h2>

        {/* Display success/error messages */}
        {/* {message.text && (
          <div
            className={`p-2 mb-4 rounded-md ${
              message.field_type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )} */}

        {/* Static Fields */}
        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="buyer_added_by" className="block">
              Buyer Added By<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Buyer Added By",placeholder:"Administrator"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              value={data?.buyer_added_by || ""}
              name="buyer_added_by" // Add a name for the field
              placeholder="Administrator"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              onChange={(e) =>
                handleInputChange(e, { column_name: "buyer_added_by" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            />
          </div>

          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="buyer_added_date" className="block">
              Buyer Added Date<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Buyer Added Date",placeholder:"12/11/2024"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              value={data?.buyer_added_date || ""}
              name="buyer_added_date" // Add a name for the field
              placeholder="12/11/2024"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              onChange={(e) =>
                handleInputChange(e, { column_name: "buyer_added_date" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            />
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="buyersource" className="block">
                Buyer Source<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Buyer Source",placeholder:"Select Buyer Source"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <select
                id="buyersource"
                value={data?.buyersource || ""}
                name="buyersource" // Add a name for the field
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "buyersource" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              >
                <option>Select Buyer Source</option>
              </select>
            </div>

             <div>
              <div className="flex items-center justify-between">
              <label htmlFor="buyerstage" className="block">
                Buyer Stage<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Buyer Stage",placeholder:"Select Buyer Stage"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <select
                id="buyerstage"
                value={data?.buyerstage || ""}
                name="buyerstage" // Add a name for the field
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "buyerstage" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              >
                <option>Select Buyer Stage</option>
              </select>
            </div>

          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="lastUpdated" className="block">
              Buyer Last Updated By<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Buyer Last Updated By",placeholder:"Executives"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              value={data?.lastUpdated || ""}
              name="lastUpdated" // Add a name for the field
              placeholder="Executives"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              onChange={(e) =>
                handleInputChange(e, { column_name: "lastUpdated" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            />
          </div>

               <div>
                <div className="flex items-center justify-between">
              <label htmlFor="nextstep" className="block">
                Next Step<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Next Step",placeholder:"Select next step"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <select
                id="nextstep"
                value={data?.buyersource || ""}
                name="nextstep" // Add a name for the field
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "nextstep" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              >
                <option>Select Next Step</option>
              </select>
            </div>

            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="buyerowner" className="block">
                Buyer Owner<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Buyer owner",placeholder:"Select Buyer owner"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <select
                id="buyerowner"
                value={data?.buyersource || ""}
                name="buyerowner" // Add a name for the field
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "buyerowner" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              >
                <option>Select Buyer Owner</option>
              </select>
            </div>

            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="buyerrecomendedfor" className="block">
                Buyer Recomended For<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Buyer Recommend For",placeholder:"Select Buyer recommended for"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <select
                id="buyerrecomendedfor"
                value={data?.buyersource || ""}
                name="buyerrecomendedfor" // Add a name for the field
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "buyerrecomendedfor" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              >
                <option>Select Buyer Recomended For</option>
              </select>
            </div>

          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="tags" className="block">
              Tags<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Tags",placeholder:"Enter tags"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              value={data?.tags || ""}
              name="tags" // Add a name for the field
              placeholder="Enter Tags"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              onChange={(e) =>
                handleInputChange(e, { column_name: "tags" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            />
          </div>
          <AssignedToMain Message={Message} require={require} onFieldChange={onFieldChange} setFormData={setFormData} setEditModalOpen={setEditModalOpen}/>
        </form>

        {/* Dynamic Fields Rendering */}
        {dynamicFields.length > 0 && (
          <div className="mt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
              {dynamicFields.map(
                (field, index) =>
                  field.division == "Buyer Management Details" && (
                    <div key={field?.column_name || index}>
                      <div className="flex justify-between">
                        <label className="block">
                          {field?.field_label
                            ? field.field_label.replace(/_/g, " ")
                            : "Unlabeled Field"}
                          {field?.is_required && (
                            <span className="text-red-500">*</span>
                          )}
                        </label>
                        <div
                          className={`gap-[5px] ${hidden ? "hidden" : "flex"}`}
                        >
                          <button
                            className="color-[#979797]"
                            onClick={() => handleOpenEditModal(field)}
                          >
                            <MdOutlineEdit className="color-[#979797]" />
                          </button>
                          <button
                            className="color-[#979797]"
                            onClick={() => handleDeleteField(field)}
                          >
                            <MdDeleteOutline className="color-[#979797]" />
                          </button>
                        </div>
                      </div>

                      {/* Render Inputs Based on Type */}
                      {field?.field_type === "text" ||
                      field?.field_type === "date" ||
                      field?.field_type === "number" ? (
                        <input
                          value={data?.[field.column_name] || ""}
                          type={field.field_type}
                          name={field.column_name} // Use column_name as the field name
                          placeholder={field?.placeholder || ""}
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                          disabled={require}
                          readOnly={require}
                        />
                      ) : field?.field_type === "radio" ||
                        field?.field_type === "checkbox" ? (
                        field?.options?.split(",").map((option) => (
                          <div
                            key={option}
                            className="flex items-center space-x-2 mt-1"
                          >
                            <input
                              value={data?.[field.column_name] || { option }}
                              type={field.field_type}
                              id={option}
                              name={field.column_name}
                              // value={option}
                              onChange={(e) => handleInputChange(e, field)}
                              disabled={require}
                              readOnly={require}
                            />
                            <label htmlFor={option}>{option}</label>
                          </div>
                        ))
                      ) : field?.field_type === "dropdown" ? (
                        <select
                          name={field.column_name} // Use column_name as the field name
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                          disabled={require}
                          readOnly={require}
                        >
                          <option disabled>
                            Select{" "}
                            {field?.column_name
                              ? field.column_name.replace(/_/g, " ")
                              : "Field"}
                          </option>
                          {field?.options?.split(",").map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      ) : null}
                    </div>
                  )
              )}
            </div>
          </div>
        )}

        {/* Add Field Button */}
         <div className='grid grid-cols-2 items-center px-10 mt-6'>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
        </div>
      </div>

      <FieldEditModal
        isOpen={isEditModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSave}
        formData={formData}
        setFormData={setFormData}
        content={"Buyer Management Details"}
      />

      {/* Add Custom Field Modal */}
      <CustomFieldModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        division={division}
      />

      {/* Edit Custom Field Modal */}
      <EditCustomFieldModal
        isOpen={showEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleSubmitUpdateField}
        fieldData={selectedField}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
      <ToastContainer />
    </>
  );
};

export default BuyerManagementDetails;
